$(function () {
    $(".numberonly").on("keypress", function (e) {
        numberonly(e);
    });

    function numberonly(e) {
        var ev = e || window.event;
        var key = ev.keyCode || ev.which;
        key = String.fromCharCode(key);
        var regex = /[0-9]/;
        if (!regex.test(key)) {
            ev.returnValue = false;
            if (ev.preventDefault) ev.preventDefault();
        }
    }

    $(".useful-info .card-body").matchHeight();

    $(".useful-info .card").click((e) => {
        let text = $(e.target)
            .closest(".card")
            .find(".card-title")
            .text()
            .trim();

        $("#modal-breakdown-glossary .modal-title").text(text);
    });

    $(window).on("resize", function () {
        $(".c-height").matchHeight();
        $(".i-height").matchHeight();
        $(".info-body").matchHeight();
    });
    $(window).trigger("resize");
});
